import { cn } from '@/lib/utils'
import { formatNumber, formatUSD } from '@/lib/format-utils'

export const countryColumn = {
  id: 'country',
  header: '#',
  accessorFn: (row) => row.country,
  cell: (row) => {
    const country = row.getValue()
    return <div>{country}</div>
  },
  meta: {
    sticky: true,
    stickyLeft: 'left-[0px]',
  },
}

export const pidColumn = (p) => ({
  id: `pid-cost-${p.code}`,
  header: `${p.name}`,
  accessorFn: (row) => {
    const baseline = row.baselines?.[p.code]
    const cost = typeof baseline === 'object' ? baseline?.value : baseline
    return { pid: p.code, cost, baseline }
  },
  cell: (row) => {
    const { cost } = row.getValue()

    // 如果cost不存在,返回null
    if (cost === null || cost === undefined) {
      return null
    }

    const formatted = formatUSD(cost, 0, 0)

    return (
      <div className="text-right">
        {formatted}
      </div>
    )
  },
})
